import { transformMessageToChatMessage, transformChannelToRoom } from '../transformers/twilioImportTransformer'

export default class TwilioEventsAdaptor {

    constructor(hooks) {
        return {
            channelAdded: async (channel) => {
                await this.tryJoinChannel(channel)
                hooks.onAddedToRoom(
                    await transformChannelToRoom(channel)
                );
            },
            channelRemoved: (channel) => {
                console.log('not yet supported');
            },
            messageAdded: async (message) => {
                hooks.onMessage(
                    await transformMessageToChatMessage(message)
                )
            },
            connectionError:(terminal, message, httpStatusCode, errorCode)=>{
                // TODO: translate twilio message to my message
                var errMessage = message
                hooks.connectionError(errMessage)
            }
        };
    }

    async tryJoinChannel(channel){
        try {
            await channel.join(); // join and subscribe to this channels events
            return;
        } catch (error) {
            return;
        }
    }
}





// WEBPACK FOOTER //
// ./src/third-party/twilio/chat/transformers/TwilioEventsAdaptor.js